import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Observable, filter, debounceTime, distinctUntilChanged, map } from 'rxjs';
import { MsgModel } from '../msg/model/msg.model';

@Component({
    selector: 'input-password',
    templateUrl: './input-password.component.html',
    styleUrls: ['./input-password.component.scss']
})
export class InputPasswordComponent implements OnInit {
    @Input() matLabel: string = 'Password';
    @Input() placeholder: string = 'Password';
    @Input() form!: UntypedFormGroup;
    @Input() controlName!: string;

    @Input() passwordToConfirm: string = '';
    @Output() passwordToConfirmChange: EventEmitter<string> = new EventEmitter<string>();

    hide: boolean = true;
    isLoading: boolean = false;
    msg!: MsgModel;
    progress: number = 0;
    progressColor: string = 'warn';

    myControl: any;
    filteredOptions!: Observable<any>;

    minCharacters: number = 1;

    constructor() {}

    ngOnInit(): void {
        this.myControl = <UntypedFormControl>this.form.get(this.controlName);

        this.filteredOptions = this.myControl.valueChanges.pipe(
            // only search if search string is >= 1 characters
            //filter((text: string) => text !== null && text.length >= this.minCharacters),
            debounceTime(500),
            distinctUntilChanged(),
            map((value) => this.checkPassword(value))
        );
    }

    checkPassword(password: any) {
        this.isLoading = true;

        this.validatePassword(password);
        this.passwordToConfirmChange.emit(password);

        this.isLoading = false;
    }

    validatePassword(password: string) {
        const checks = [
            { error: 'Lowercase', regex: new RegExp('^(?=.*[a-z])') },
            { error: 'Uppercase', regex: new RegExp('^(?=.*[A-Z])') },
            { error: 'Number', regex: new RegExp('^(?=.*[0-9])') },
            { error: 'Special Character', regex: new RegExp('^(?=.*[!@#$%^&*`~])') },
            { error: '8 Characters', regex: new RegExp('^(?=.{8,})') }
        ];

        let passwordError = false;
        let errorMsg = '';
        let progress = 0;

        checks.forEach((check) => {
            let currentCheckValid = false;
            currentCheckValid = check.regex.test(password);

            if (!currentCheckValid) {
                passwordError = true;

                errorMsg += errorMsg.length === 0 ? check.error : ', ' + check.error;
            } else {
                progress += 100 / checks.length;
            }
        });

        errorMsg += ' required.';

        if (passwordError) {
            this.msg = { SUCCESS: false, MSG: errorMsg };
        } else {
            this.msg = { SUCCESS: true, MSG: 'Password is valid' };
        }

        this.progress = progress;

        if (this.progress <= 33) {
            this.progressColor = 'warn';
        } else if (this.progress > 33 && this.progress <= 66) {
            this.progressColor = 'accent';
        } else if (this.progress === 100) {
            this.progressColor = 'primary';
        }
    }

    toggleHide() {
        this.hide = !this.hide;
    }
}
